import { j as o } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as i } from "react";
import { I as r } from "../../../../IconBase-CxZyIWw2.js";
const s = i(
  (e, a) => /* @__PURE__ */ o.jsx(
    r,
    {
      ref: a,
      ...e,
      image: (l) => /* @__PURE__ */ o.jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: 16,
          height: 16,
          fill: "none",
          viewBox: "0 0 16 16",
          ...l,
          children: /* @__PURE__ */ o.jsx(
            "path",
            {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M1 2a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1zm6.5 7.907L2 6.732v-2.31l6 3.465 6-3.464v2.309L8.5 9.907a1 1 0 0 1-1 0",
              clipRule: "evenodd"
            }
          )
        }
      )
    }
  )
);
s.displayName = "MailIcon";
export {
  s as MailIcon,
  s as default
};
//# sourceMappingURL=index.js.map
